module.exports = __webpack_public_path__ + "img/k10.99f80d91.png";